module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-500-0866c24487514ad726738fb24f8e015b.woff2";